import { SNOW_COLORS } from 'utils/snowfall';
import { FormattedMessage } from 'react-intl';
import { useSnowSettings } from 'providers/snow-settings';
import { Box, FormControlLabel, Switch, Typography, RadioGroup, Radio, Stack } from '@mui/material';

const SnowSettingsPanel = () => {
  const { enabled, setEnabled, colorId, setColorId } = useSnowSettings();

  return (
    <Box sx={{ p: 2, width: 280 }}>
      <Typography variant="subtitle1" fontWeight={700} gutterBottom>
        <FormattedMessage id="snow.title" defaultMessage="Kar Efekti" />{' '}
      </Typography>

      <FormControlLabel
        control={<Switch checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />}
        label={
          enabled ? (
            <FormattedMessage id="snow.state.on" defaultMessage="Açık" />
          ) : (
            <FormattedMessage id="snow.state.off" defaultMessage="Kapalı" />
          )
        }
      />

      <Typography variant="caption" sx={{ display: 'block', mt: 1.5, mb: 1, opacity: 0.8 }}>
        <FormattedMessage id="snow.color.title" defaultMessage="Kar Rengi" />
      </Typography>

      <RadioGroup value={colorId} onChange={(e) => setColorId(e.target.value)}>
        <Stack gap={1}>
          {SNOW_COLORS.map((opt) => (
            <Box key={opt.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Radio size="small" value={opt.id} />
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: '50%',
                  backgroundColor: opt.rgba,
                  border: '1px solid rgba(0,0,0,0.25)',
                }}
              />
              <Typography variant="body2">
                <FormattedMessage id={opt.labelId} defaultMessage={opt.id} />
              </Typography>
            </Box>
          ))}
        </Stack>
      </RadioGroup>
    </Box>
  );
};

export default SnowSettingsPanel;
